/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";
import { Equipment } from "../componentObjects";

const controller = "/partners";
class PartnerService {

    //set isActive = false for VersionCheck  
    async get(obj) { 
        const response = await http.post(`${controller}/getpartnerlist`, obj); 
        const data = await response.data;
        return data;
    }
    async getmainpartners(organization) {
        const response = await http.get(`${controller}/mainpartners?organization=${organization}`);
        const data = await response.data;
        return data;
    }
    async addnewpartner(partner) {
        const response = await http.post(`${controller}/addnewpartner`, partner);
        const data = await response.data;
        return data;
    }

    async refreshdashboardsection(section, currInfo) {
        const response = await http.post(`${controller}/refreshdashboardsection?section=${section}`, currInfo);
        const data = await response.data;
        return data;
    }

    async getallstateassets(requestObj) {
        const response = await http.post(`${controller}/getallstateassets`, requestObj);
        const data = await response.data;
        return data;
    }

    async getonboardingsummary(orgId) {
        const response = await http.get(`${controller}/getonboardingsummary?orgId=${orgId}`);
        const data = await response.data;
        return data;
    }
    
    async getonboardinginfo(orgId, assetType = Equipment.AIR_CONDITIONER, isRetrain = false) {
        const response = await http.get(`${controller}/getonboardinginfo?orgId=${orgId}&assetType=${assetType}&isRetrain=${isRetrain}`);
        const data = await response.data;
        return data;
    }
    
    async gettrainingsessioninfo(session) {
        const response = await http.post(`${controller}/gettrainingsessioninfo`, session);
        const data = await response.data;
        return data;
    }

    async getassettraininginfo(orgId, assetType = Equipment.AIR_CONDITIONER, isRetrain = false) {
        const response = await http.get(`${controller}/getassettraininginfo?orgId=${orgId}&assetType=${assetType}&isRetrain=${isRetrain}`);
        const data = await response.data;
        return data;
    }

    async updateservicetier(partnerId,tierId) {
        const response = await http.post(`${controller}/updateservicetier?partnerId=${partnerId}&tierId=${tierId}`);
        const data = await response.data;
        return data;
    }

    async updatemuteuntilalert(partnerId, muteUntilDate) {
        const response = await http.post(`${controller}/updatemuteuntilalert?partnerId=${partnerId}&muteUntilDate=${muteUntilDate}`);
        const data = await response.data;
        return data;
    }

    async adddeletedinfrastructure(partnerId, partnerCompanyName) {
        const response = await http.post(`${controller}/adddeletedinfrastructure?partnerId=${partnerId}&partnerCompanyName=${partnerCompanyName}`);
        const data = await response.data;
        return data;
    }

    async searchpartnerassets(partnerId,classId) {
        const response = await http.get(`${controller}/searchpartnerassets?partnerId=${partnerId}&classId=${classId}`);
        const data = response.data;
        return data;
    }

    async getpartnerproperties(partnerId,classId) {
        const response = await http.get(`${controller}/partnerproperties?partnerId=${partnerId}`);
        const data = response.data;
        return data;
    }

    async getinstallbyorgid(partnerId) {
        const response = await http.get(`${controller}/getinstallbyorgid?orgId=${partnerId}`);
        const data = response.data;
        return data;
    }
    
    async softdelete(organizationId){
        
        const response = await http.delete(`${controller}/softdelete/${organizationId}`);
        const data = await response.data;
        return data;
    }
    async resurrect(organizationId){

        const response = await http.post(`${controller}/resurrect/${organizationId}`);
        const data = await response.data;
        return data;
    }
    
    async softdelete(organizationId){
        
        const response = await http.delete(`${controller}/softdelete/${organizationId}`);
        const data = await response.data;
        return data;
    }
    async resurrect(organizationId){

        const response = await http.post(`${controller}/resurrect/${organizationId}`);
        const data = await response.data;
        return data;
    }
}

export default new PartnerService();
